import { Chip } from "@material-ui/core";
import { green, yellow } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const STATUS_COLOR_MAP = {
	active: green[500],
	paused: yellow[500],
};
const STATUS_ICON_MAP = {
	active: CheckCircleIcon,
	paused: PauseCircleFilledIcon,
};

const StatusField = ({ source, record }) => {
	const translate = useTranslate();
	const status = get(record, source);
	const color = get(STATUS_COLOR_MAP, status, "");
	const statusLabel = translate(`resources.bookmakers.status.${status}`);
	const Icon = STATUS_ICON_MAP[status];
	return (
		<Chip
			icon={<Icon style={{ color: "white" }} />}
			label={statusLabel}
			style={{
				backgroundColor: color,
				color: "white",
			}}
		/>
	);
};
export default StatusField;
